import React, { useState } from "react";
import styled from "styled-components";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import About from "./components/About";
import Contact from "./components/Contact";

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;

function App() {
  const [activeSection, setActiveSection] = useState("home");

  return (
    <AppContainer>
      <Header
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      <Hero />
      <Projects />
      <About />
      <Contact />
    </AppContainer>
  );
}

export default App;
